// Where a brand's published testimonials show, as the workspace payload defines it once for every screen: a widget is
// live after its first view on a site (`live_widgets`), the hosted wall once it is live (`wall_live`), and only on
// a brand whose public pages are on. The Overview line, the first-run checklist and the publish messages agree.
import { plural } from './format';

export function showsPublicly(brand) {
  return !!brand && ((brand.live_widgets || 0) > 0 || !!brand.wall_live);
}

export function placesOf(brand) {
  const widgets = (brand && brand.live_widgets) || 0;
  const wall = !!brand && !!brand.wall_live;
  if (widgets && wall) return 'your ' + (widgets === 1 ? 'widget' : 'widgets') + ' and wall';
  if (widgets) return 'your ' + (widgets === 1 ? 'widget' : 'widgets');
  return wall ? 'your wall' : '';
}

// What shows a testimonial when nothing does yet: a widget on the site (new, or one not installed yet) or the wall.
export const NOT_SHOWING = 'Put a widget on your site or your wall live to show ';

// The toast after publishing `count` testimonials of the given brands: {text, action}. Where nothing shows them
// yet, it says how to show them, with a link to the widgets.
export function publishedToast(brands, count) {
  const list = (Array.isArray(brands) ? brands : [brands]).filter(Boolean);
  const head = count === 1 ? 'Published.' : 'Published ' + plural(count, 'testimonial') + '.';
  if (!list.length) return { text: head };
  const showing = list.filter(showsPublicly);
  if (showing.length === list.length) {
    const places = list.length === 1 ? placesOf(list[0]) : 'your widgets and walls';
    return { text: head + ' ' + (count === 1 ? 'It\'s' : 'They\'re') + ' live on ' + places + ' within a minute.' };
  }
  if (!showing.length) {
    return { text: head + ' ' + NOT_SHOWING + (count === 1 ? 'it' : 'them') + '.',
      action: { label: 'Get the widget', to: '/widgets' } };
  }
  return { text: head };
}
